import * as React from 'react';

interface BentoPortionProps {
  name: string;
  local?: boolean;
}

export class BentoPortion extends React.Component<BentoPortionProps> {
  public render() {
    return this.props.children || null;
  }
}
